import React from 'react';
import { makeStyles, Checkbox } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@material-ui/icons/Remove';

interface CheckBoxProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  value: string;
  disabled?: boolean;
  checked?: boolean;
  variant?: 'checked' | 'removals';
  className?: string;
  iconClassName?: string;
  inputProps?: any;
}

const styles = makeStyles(({ palette, spacing }: any) => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    padding: 0,
    marginRight: spacing(3),
  },
  icon: {
    backgroundColor: palette.background.textInput,
    borderRadius: 5,
    width: spacing(4.5),
    height: spacing(4.5),
  },
  checkedIcon: {
    width: spacing(4.5),
    height: spacing(4.5),
    backgroundColor: palette.action.active,
    fill: palette.common.white,
    borderRadius: 5,
  },
}));

const CheckBox = ({
  onChange,
  value,
  inputProps,
  disabled = false,
  variant = 'checked',
  checked = false,
  className,
  iconClassName,
}: CheckBoxProps) => {
  const classes = styles();

  const icon =
    variant === 'removals' ? (
      <RemoveIcon className={classes.checkedIcon} />
    ) : (
      <CheckIcon className={classes.checkedIcon} />
    );

  return (
    <Checkbox
      className={`${classes.root} ${className}`}
      icon={<span className={`${classes.icon} ${iconClassName}`} />}
      checkedIcon={icon}
      onChange={onChange}
      value={value}
      inputProps={inputProps}
      disabled={disabled}
      checked={checked}
    />
  );
};

export default CheckBox;
